import * as React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TreeItem } from "@mui/x-tree-view";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { VscMarkdown } from "react-icons/vsc";
import { SimpleTreeView } from '@mui/x-tree-view'

interface Page {
  index: number;
  name: string;
  route: string;
}

interface Props {
  pages: {
    index: number;
    name: string;
    route: string;
  }[];
  selectedIndex: number;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
  currentComponent: string;
  setCurrentComponent: React.Dispatch<React.SetStateAction<string>>;
  visiblePageIndexs: number[];
  setVisiblePageIndexs: React.Dispatch<React.SetStateAction<number[]>>;
}

export default function AppTree({
  pages,
  selectedIndex,
  setSelectedIndex,
  currentComponent,
  setCurrentComponent,
  visiblePageIndexs,
  setVisiblePageIndexs,
}: Props) {
  const navigate = useNavigate();
  const theme = useTheme();
  // const [selectedIndex, setSelectedIndex] = useState(-1);
  let { pathname } = useLocation();

  pages = [
    {
      index: -1,
      name:'Home',
      route: '/'
    },
    {
      index: 0,
      name:'Highscores',
      route: '/highscores'
    },
    {
      index: 1,
      name:'Spy',
      route: '/spy'
    },
    {
      index: 2,
      name:'Wiki',
      route: '/wiki'
    },
    {
      index: 3,
      name:'GUIDSE',
      route: '/guide'
    },
    {
      index: 4,
      name:'Updates',
      route: '/updates'
    },
    {
      index: 5,
      name:'Prizes',
      route: '/prizes'
    },
    {
      index: 6,
      name:'Playershops',
      route: '/playershops'
    }
  ]
  const page: Page = pages.find((x) => x.route === pathname)!;

  useEffect(() => {
    if (page) {
      setSelectedIndex(page.index);
    }
  }, [page, setSelectedIndex]);

  function renderTreeItemBgColor(index: number) {
    if (theme.palette.mode === "dark") {
      return selectedIndex === index ? "rgba(144,202,249,0.16)" : "#252527";
    } else {
      return selectedIndex === index ? "#295fbf" : "#f3f3f3";
    }
  }

  function renderTreeItemColor(index: number) {
    if (theme.palette.mode === "dark") {
      return selectedIndex === index && currentComponent === "tree"
        ? "white"
        : "#bdc3cf";
    } else {
      return selectedIndex === index ? "#e2ffff" : "#69665f";
    }
  }

  function toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  return (
    <SimpleTreeView
      aria-label="file system navigator"
      slots={{
        collapseIcon: ExpandMoreIcon,
        expandIcon: ChevronRightIcon,
      }}
      sx={{ minWidth: 220 }}
      defaultExpandedItems={["-1"]}
    >
      {/* <TreeItem
        nodeId="-1"
        label="Home"
        color="#bdc3cf"
        onClick={() => {
          navigate("/");
          setSelectedIndex(-1);
        }}
      > */}
        {pages.map(({ index, name, route }) => {  console.log("a page:", index, name, route); return(
         


          <TreeItem
        itemId={''+(index)+''}
        label={toTitleCase(name)}
        color="#bdc3cf"
        onClick={() => {
          if (!visiblePageIndexs.includes(index)) {
            setVisiblePageIndexs([...visiblePageIndexs, index]);
          }
          navigate(route);
          setSelectedIndex(index);
          setCurrentComponent("tree");
        }}
      >
        </TreeItem>
        )})}

          {/* <TreeItem
            key={index}
            nodeId={index.toString()}
            label={toTitleCase(name)}
            sx={{
              color: renderTreeItemColor(index),
              backgroundColor: renderTreeItemBgColor(index),
              "&& .Mui-selected": {
                backgroundColor: renderTreeItemBgColor(index),
              },
            }}
            icon={<VscMarkdown color="#6997d5" />}
            onClick={() => {
              if (!visiblePageIndexs.includes(index)) {
                const newIndexs = [...visiblePageIndexs, index];
                setVisiblePageIndexs(newIndexs);
              }
              navigate(route);
              setSelectedIndex(index);
              setCurrentComponent("tree");
            }}
          />
        )})}
      </TreeItem> */}
    </SimpleTreeView>
  );
}
